// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalContent_header__RmH4z","clearButton":"ModalContent_clearButton__6-wmt","content":"ModalContent_content__24HY2"};